const ResiDisclaimerConfig = {
	Title : "Residential Disclaimer Tool",
	AppID: "ResiDisclaimer",

	CLIENT_ID: '170764070601-s6m88vafpqf9oeho9qq7o845g22tutde.apps.googleusercontent.com',
	API_KEY: 'AIzaSyBSvxvmgZaiFxBGiraq8m88umSpaABxtWs',

	/* 
	Spreadsheet columns are from left to right: Key (ID) value, then 'Regions' (tabs), then the disclaimer data keys. 
	
	Warning: When adding a column, be sure to update SHEET_RANGE and SHEET_RANGE_RTF 
	*/

	//SHEET_ID : "1mGduhheVsYm1EBEegUFUDcHWIaihibOdqhTMGxjL3Jc",
	SHEET_ID: "1fIxx7YzDrbBaG7OjO74feH905B4DnzguMrgCvLTzCtE",
	SHEET_RANGE: 'ResiDisclaimers!A2:I',
	SHEET_RANGE_RTF: 'ResiDisclaimers!H2:H',

	UserSettingsSheet: true, 
	USERSETTINGS_SHEET_RANGE: 'ResiSettings!A2:B', 

	FormClass: 'resi-disclaimer-form',
	DisplayRTF: true, 
	AllowReordering: true, 
	StickyLegalText: true, 
	DefaultLoginMode: 2,

	RegionKeys: ['standard', 'beta'], 
	DataKeys: ['section', 'type', 'desc', 'symbol', 'legal', 'tip'],
	LegalColumn: 'legal', 
	TipColumn: 'tip', 

	RegionSection: "Region",
	OfferTypeSection: "OfferType",
	OfferTypeAll : "alloffertypes", 

	Sections : [
		{
			"key": "Region",
			"label": "Type",
			"type": "tabs",
			"autoSelect": true,
		},
		{
			"key": "Intro",
			"label": "Intro Disclaimer",
			"type": "single",
			"filterRegion": true,
			"filterOfferType": false,
			"autoSelect": true
		},
		{
			"key": "IntroAddOn",
			"label": "Intro Add On",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType": true,
			"product": "I",
			"closed": false, 
		},
		{
			"key": "Internet",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType": true,
			"product": "I",
			"heading": "teal",
		},
		{
			"key": "Internet Claims",
			"label": "Internet Claims",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType": true,
			"product": "I"
		},
		{
			"key": "Mobile",
			"label": "Mobile",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType": true,
			"product": "M",
			"heading": "teal",
		},
		{
			"key": "Mobile Claims",
			"label": "Mobile Claims",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType": true,
			"product": "M"
		},
		{
			"key": "Video",
			"label": "Video",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType": true,
			"product": "T",
			"heading": "teal",
		},
		{
			"key": "Video Claims",
			"label": "Video Claims",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType": true,
			"product": "T"
		},
		{
			"key": "Voice",
			"label": "Voice",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType": true,
			"product": "P",
			"heading": "teal",
		},
		{
			"key": "Specialized",
			"label": "Specialized Offers",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType": true,
			"heading": "green",
		},
		{
			"key": "General Claims",
			"label": "General Claims",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType": true,
			"heading": "green",
		},
		{
			"key": "EndDisclaimer",
			"label": "End Disclaimer",
			"type": "single",
			"filterRegion": true,
			"filterOfferType": true,
			"autoSelect": true
		},	
		{
			"key": "Copyright",
			"label": "Copyright",
			"type": "single",
			"filterRegion": true,
			"filterOfferType": true,
			"autoSelect": true,
		},	
	],

	SecretPassword: "1a7d15f5eaede388bc59dd740eb93d4e946707b6",
	/* SecretPassword: "ca3979a3fb9356b99af9ccfad192ea6dea929c73", */
	
	/* methods */
	
	// return array of section names 
	getSections : function() {
		let out = [];
		this.Sections.forEach( (sec) => {
			out.push(sec.key);
		});
		return out; 
	},

	
};

export default ResiDisclaimerConfig;
